<template>
  <div>
    <card-modal :showing="showing" class="px-4 py-2" @close="close()">
      <h2 class="font-bold text-3xl">Edit Discount</h2>
      <trashed-message v-if="discount.deleted_at" class="mb-6" @restore="restore"> This discount has been deleted. </trashed-message>
      <form class="mt-6" @submit.prevent="update">
        <div class="flex items-center justify-between">
          <label class="form-label">Value</label>
          <text-input v-model="form.value" type="number" :step="0.01" min="0" :error="form.errors.value" class="w-1/2" />
        </div>
        <div class="flex flex-row-reverse items-center justify-between mt-6">
          <div class="flex items-center justify-end">
            <a class="border text-blue-800 border-blue-800 px-4 py-2 mr-4 cursor-pointer hover:text-white hover:bg-blue-600" @click.stop="close()">Cancel</a>
            <loading-button :loading="form.processing" class="btn-blue px-4 py-2" type="submit">Update Discount</loading-button>
          </div>
          <button v-if="! discount.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Discount</button>
        </div>
      </form>
    </card-modal>
  </div>
</template>

<script>
import TrashedMessage from '@/Shared/TrashedMessage'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import CardModal from '@/Shared/CardModal'

export default {
  components: {
    TrashedMessage,
    LoadingButton,
    TextInput,
    CardModal,
  },
  // remember: 'form',
  props:{
    discount: Object,
  },
  emits: ['close'],
  data() {
    return {
      showing: true,
      form: this.$inertia.form({
        value : this.discount.value,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/discounts/${this.discount.id}`, {
        onSuccess: () => {
          this.close()
        },
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this discount?')) {
        this.form.delete(`/discounts/${this.discount.id}`, {
          onSuccess: () => {
            this.close()
          },
        })
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this discount?')) {
        this.form.put(`/discounts/${this.discount.id}/restore`, {
          onSuccess: () => {
            this.close()
          },
        })
      }
    },
    close() {
      this.form.reset()
      this.showing = false
      this.$emit('close')
    },
  },
}
</script>
